import { render, staticRenderFns } from "./DropdownWithValidData.vue?vue&type=template&id=ec80f714"
import script from "./DropdownWithValidData.vue?vue&type=script&lang=js"
export * from "./DropdownWithValidData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports